import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Pdf = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="pdf icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 6.82843C3 6.29799 3.21071 5.78929 3.58579 5.41421L8.41421 0.585787C8.78929 0.210714 9.29799 0 9.82843 0L19 0C20.1046 0 21 0.895431 21 2V22C21 23.1046 20.1046 24 19 24H5C3.89543 24 3 23.1046 3 22V6.82843ZM10 7V2.5L5.5 7H10ZM6.24 11.28V16.1116H7.1373V14.2204H7.99319C9.01474 14.2204 9.50481 13.5923 9.50481 12.7502C9.50481 11.9081 9.01474 11.28 7.99319 11.28H6.24ZM7.95868 13.3921H7.1373V12.1083H7.95868C8.35212 12.1083 8.5937 12.3084 8.5937 12.7502C8.5937 13.1919 8.35212 13.3921 7.95868 13.3921ZM10.2779 11.28V16.1116H11.6376C12.8455 16.1116 13.9568 15.3869 13.9568 13.6958C13.9568 12.0047 12.8455 11.28 11.6376 11.28H10.2779ZM11.5617 15.2834H11.1752V12.1083H11.5617C12.1967 12.1083 13.0457 12.412 13.0457 13.6958C13.0457 14.9797 12.1967 15.2834 11.5617 15.2834ZM17.76 11.28H14.7437V16.1116H15.641V14.0064H17.4218V13.1781H15.641V12.1773H17.76V11.28Z"
    />
  </svg>
)
